import { Link,useNavigate } from "react-router-dom";
import "./faq.css"
import { useState } from "react";
//import "../../pages/app-wide.css";
import { motion, AnimatePresence } from "framer-motion";


const FAQContainer = ({}) => {
    const [openIndex, setOpenIndex] = useState(null);

    const toggleQuestion = (index) => {
      setOpenIndex(openIndex === index ? null : index);
    };

    const faqData = [
        {
          question: "What Stocks and ETFs Does the Stock Archives API Support?",
          answer: "Stock Archives supports a growing range of stocks and ETFs, including companies such as Apple Inc., Nvidia Corp., Microsoft Corp., Amazon Inc., Alphabet Inc., Meta Platforms Inc., Whirlpool Corp., Nordstrom Inc., and Broadcom Inc. Supported ETFs include IJT, EEM, IWP, IYW, and many more."
        },
        {
          question: "What Supplementary Data Is Provided by the Stock Archives API?",
          answer: "Stock Archives provides a wide range of historical economic and market indicators, including CPI, GDP, Real GDP, Nonfarm Payrolls, Unemployment Rate, 30-Year Mortgage Rates, and more."
        },
        {
          question: "How Far Back Does the Stock Archives API Provide Data?",
          answer: "Stock Archives supports a growing range of stocks and ETFs, including companies such as Apple Inc., Nvidia Corp., Microsoft Corp., Amazon Inc., Alphabet Inc., Meta Platforms Inc., Whirlpool Corp., Nordstrom Inc., and Broadcom Inc. Supported ETFs include IJT, EEM, IWP, IYW, and many more."
        }
      ];


  return (
    <div className="faq-home-container">
      <div className="faq-home-container-inner">
        <div className="faq-home-container-inner-left">
          <p className="faq-home-sub-header">FAQ</p>
          <p className="faq-home-header">Frequently Asked Questions</p>
        </div>

        <div className="faq-home-container-inner-right">
          {faqData.map((item, index) => {
            const isOpen = openIndex === index;

            return (
              <div
                key={index}
                className="faq-home-container-inner-right-question"
                onClick={() => toggleQuestion(index)}
              >
                {/* Question Header */}
                <div onClick={() => toggleQuestion(index)} className="faq-home-container-inner-right-question-upper">
                  <div className="faq-home-question-container">
                    <p className="faq-home-question-header">
                      {item.question}
                    </p>
                  </div>

                  <div className="faq-home-question-plus-container">
                    <button onClick={() => toggleQuestion(index)} className="faq-home-question-plus-container-button">
                    {isOpen ? "−" : "+"}
                    </button>
                  </div>
                  <motion.div
                                    className="faq-home-container-underline"
                                    initial={{ scaleX: 1 }}
                                    animate={{ scaleX: isOpen ? 0 : 1 }}
                                    transition={{ duration: 0.25 }}
                                    style={{ transformOrigin: "left" }}
                                />
                  
                </div>




                {/* Animated Answer */}
                <AnimatePresence className="faq-home-container-inner-right-question-hidden-2" initial={false}>
                  {isOpen && (
                    
                    <motion.div
                      className="faq-home-container-inner-right-question-hidden"
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "175px", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3, ease: "easeInOut" }}
                      style={{ overflow: "hidden" }}
                    >
                        <ul>
                            <li>{item.answer}</li>
                        </ul>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FAQContainer;